import React from 'react';
import { External } from 'core/icons';
import { StyledAnchor } from './styled';

const Anchor = ({ href, download, type, children, useIcon = true }) => {
  const external = href && href.startsWith('http') && !href.includes('//faili.');

  const target = external ? '_blank' : '_self';
  const rel = external ? 'noreferrer' : type && type;
  return (
    <StyledAnchor href={href} target={target} rel={rel}>
      {children}
      {external && useIcon && <External />}
    </StyledAnchor>
  );
};

export default Anchor;



// WEBPACK FOOTER //
// ./src/elements/Anchor/Anchor.jsx